<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="sm"
                   :visible="modal.show"
                   :data="model"
                   :title="model.uuid ? $t('Edit Language') : $t('Add Language')"
                   @hidden="onHidden"
                   @show="onShow"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="is_primary" type="checkbox" :is-switch="true"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <input-widget :autofocus="true" :model="model" attribute="name" :placeholder="$t('Language')"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import InputWidget from "../../../../../core/components/input-widget/InputWidget";
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import {createNamespacedHelpers} from "vuex";
  import Language from "./Language.model";

  const {mapState, mapActions} = createNamespacedHelpers('setup/branch');

  export default {
    name: "LanguageModal",
    components: {
      InputWidget,
      ArtisioModal,
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new Language(),
      }
    },
    computed: {
      ...mapState({
        modal: state => state.languageModal,
        editObject: state => state.languageModal.object,
      }),
    },
    watch: {
      editObject() {
        if (this.editObject && this.editObject.uuid) {
          this.model = new Language(this.editObject)
        }
      }
    },
    methods: {
      ...mapActions(['hideLanguageModal', 'createLanguage', 'updateLanguage']),
      onShow() {
        this.showConfirmation = true;
      },
      onHidden() {
        this.model = new Language();
        this.hideLanguageModal();
      },
      async onSubmit() {
        let data = {
          name: this.model.name,
          branch_uuid: this.modal.object.branch_uuid,
          is_primary: this.model.is_primary
        }
        let response = null;
        this.loading = true;

        if (!this.model.uuid) {
          response = await this.createLanguage(data);
        } else {
          response = await this.updateLanguage({...data, uuid: this.modal.object.uuid});
        }

        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideLanguageModal();
          this.$toast('success', this.model.uuid ? this.$t('Language successfully updated') : this.$t('Language successfully added'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
